// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"10bdfd93","171":"776c383c","378":"3c572c4c","453":"67cef63d"}[chunkId] + ".chunk.js";
};